module.exports = __webpack_public_path__ + "static/media/1.6d68b263.jpg";